import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareViewNotFoundRoute: InvariantJiraRoute = {
	name: 'software-view-not-found',
	exact: true,
	path: '/jira/software/projects/:projectKey/not-found',
};
